import { faChevronDown, faTimes } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

export default {
  data () {
    return {
      dataSelectIssuesCategoriesValue: null,
      dataSelectOptionsIssuesCategories: [],
      dataIconDown: faChevronDown,
      dataComponentDeselect: {
        render: createElement => createElement(FontAwesomeIcon, {
          props: {
            icon: faTimes
          }
        })
      }
    };
  }
};
